import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LogService } from '@services/util/log.service';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardDataService } from '../../services/dashboard-data.service';

interface IssueOverviewData {
  total: number;
  open: number;
  inProgress: number;
  openPercentage: string;
  inProgressPercentage: string;
}

@Component({
  selector: 'app-issue-overview',
  imports: [CommonModule, TranslateModule, ButtonModule, BadgeModule],
  templateUrl: './issue-overview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IssueOverviewComponent implements OnInit {
  private readonly dashboardDataService = inject(DashboardDataService);
  private readonly log = inject(LogService);
  private readonly router = inject(Router);
  private readonly translateService = inject(TranslateService);

  // Signals for reactive state management
  protected readonly isLoading = signal(true);
  protected readonly issueData = signal<IssueOverviewData | null>(null);
  protected readonly error = signal<string | null>(null);

  ngOnInit() {
    this.loadIssueOverview();
  }

  protected loadIssueOverview() {
    this.isLoading.set(true);
    this.error.set(null);

    this.dashboardDataService.getIssueOverview().subscribe({
      next: (data) => {
        const issueOverview: IssueOverviewData = {
          total: data.total,
          open: data.open,
          inProgress: data.inProgress,
          openPercentage: data.total > 0 ? Math.round((data.open / data.total) * 100) + '%' : '0%',
          inProgressPercentage: data.total > 0 ? Math.round((data.inProgress / data.total) * 100) + '%' : '0%'
        };

        this.issueData.set(issueOverview);
        this.isLoading.set(false);
      },
      error: (error) => {
        this.log.error('Error loading issue overview:', error);
        this.error.set(this.translateService.instant('dashboard.issues.error'));
        this.isLoading.set(false);
      }
    });
  }

  protected navigateToIssues() {
    this.router.navigate(['/issues']);
  }
}
